module.exports = __webpack_public_path__ + "media/06.aed5636a.mp3";